export default function ConsentNotice() {
  return (
    <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
      <p className="text-base text-gray-700 leading-relaxed">
        This video call will be recorded and transcribed for quality and training purposes.
        Selected portions of the recording may be shared with our installation team for project preparation.
        By joining, you acknowledge and consent to this recording and use.
        If you do not consent, please let us know and do not join the call.
      </p>
    </div>
  );
}
